import { GetTargetingValuesForProviderResponse } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';

import { ActionType, createAsyncAction } from 'typesafe-actions';

import { logoutAsync } from '@bolteu/redux-session';

export interface TargetingSessionContext {
  readonly accountId: number;
  readonly sessionId: string;
}

export interface TargetingResponseContext {
  readonly requestId: number;
  readonly session: TargetingSessionContext | null;
}

export const requestTargetingParametersAsyncAction = createAsyncAction(
  '@targetingParameters/GET_TARGETING_PARAMETERS_REQUEST',
  '@targetingParameters/GET_TARGETING_PARAMETERS_SUCCESS',
  '@targetingParameters/GET_TARGETING_PARAMETERS_FAILURE',
  '@targetingParameters/GET_TARGETING_PARAMETERS_CANCEL',
)<
  { safeRefresh?: boolean },
  [GetTargetingValuesForProviderResponse, TargetingResponseContext],
  [Error, number],
  number
>();

export type TargetingParametersActions =
  | ActionType<typeof requestTargetingParametersAsyncAction>
  | ActionType<typeof logoutAsync>;
